import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { useWishlistListing } from '../WishlistPage/WishlistPage.hooks';
import useGetEnsuredCurrentUserCallback from '../../hooks/useGetEnsuredCurrentUserCallback';
import { currentUserSelector } from '../../ducks/user.duck';

export const useWishlistButton = ({ listing }) => {
  const currentUser = useSelector(currentUserSelector);
  const getEnsuredCurrentUser = useGetEnsuredCurrentUserCallback();
  const [count, setCount] = useState(listing?.attributes?.metadata?.wishlistCount || 0);
  const {
    isInWishlist,
    fetchWishlistInProgress,
    toggleWishlistInProgress,
    toggleWishlist,
  } = useWishlistListing(listing?.id?.uuid);
  const isOwnListing = currentUser?.id?.uuid && currentUser.id.uuid === listing?.author?.id?.uuid;

  return {
    count,
    checked: isInWishlist,
    disabled: fetchWishlistInProgress || toggleWishlistInProgress || isOwnListing,
    onClick: useCallback(async () => {
      if (!getEnsuredCurrentUser()) {
        return;
      }

      const addCount = isInWishlist ? -1 : 1;

      setCount(prev => (prev || 0) + addCount);

      try {
        await toggleWishlist();
      } catch {
        setCount(prev => prev - addCount);
      }
    }, [toggleWishlist, isInWishlist, getEnsuredCurrentUser]),
  };
};
